import { Directive, Input } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[libCustomAutofocus]'
})
export class CustomAutofocusDirective {
  @Input()
  public set enableAutoFocus(value:boolean){
    if(value){
      this.matInput.focus();
    }
  };

  constructor(private matInput: MatInput) {}

 

}
